var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_660)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_37_660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47911 0H1.60411C0.719559 0 0 0.719559 0 1.60411V5.72911C0 6.61383 0.719559 7.33339 1.60411 7.33339H8.47911C9.36383 7.33339 10.0834 6.61383 10.0834 5.72911V1.60411C10.0834 0.719559 9.36383 0 8.47911 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.47911 9.16661H1.60411C0.719559 9.16661 0 9.88617 0 10.7709V20.3959C0 21.2804 0.719559 22 1.60411 22H8.47911C9.36383 22 10.0834 21.2804 10.0834 20.3959V10.7709C10.0834 9.88617 9.36383 9.16661 8.47911 9.16661Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3959 14.6666H13.5209C12.6362 14.6666 11.9166 15.3862 11.9166 16.2709V20.3959C11.9166 21.2804 12.6362 22 13.5209 22H20.3959C21.2805 22 22 21.2804 22 20.3959V16.2709C22 15.3862 21.2805 14.6666 20.3959 14.6666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3959 0H13.5209C12.6362 0 11.9166 0.719559 11.9166 1.60411V11.2291C11.9166 12.1138 12.6362 12.8334 13.5209 12.8334H20.3959C21.2805 12.8334 22 12.1138 22 11.2291V1.60411C22 0.719559 21.2805 0 20.3959 0Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_37_660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.00ef385ae5286e7c515f388d2702d278.svg";
export { ForwardRef as ReactComponent };